<template>
  <Modal :id="'cmp-booking-create-invoice'" @cancelled="onCancelClick">
    <template slot="header"> {{$t('create_invoice')}} </template>
    <template slot="body">
      <SearchList
        :id="'invoice-projects'"
        :items="invoiceProjects"
        :keyProperty="'invoice_project_id'"
        :isSearchable="false"
        :label="'invoice_project_name'"
        :selectionNumber="'single'"
        @selected="onInvoiceSelected"
      />
      <!-- <v-layout row wrap>
        <v-flex>
          <div class="invoice-project--list" v-if="!loading">
            <div
              class="invoice-project--item"
              v-for="invoiceProject of invoiceProjects"
              :key="invoiceProject.invoice_project_id"
              @click="(e) => onInvoiceProjectClick(e, invoiceProject)"
            >
              {{ invoiceProject.invoice_project_name }}
            </div>
          </div>
          <LoadingTextUI v-else height="500px" :text="loadingText" />
        </v-flex>
      </v-layout> -->
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick"> {{$t('close')}} </button>
    </template>
  </Modal>
</template>

<script>
import * as R from "ramda";
import { BookingService } from "../../services/booking-service";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import Modal from "../../../../dt-plugins/modal/modal";
import { LoadingTextUI } from "../../../../plugins/loading/loading-helper";
import SearchList from "../../../../dt-plugins/search-list/search-list";

export default {
  components: {
    Modal,
    LoadingTextUI,
    SearchList,
  },
  props: ["selectedInvoiceLines", "calendarDateId"],
  data: function () {
    return {
      invoiceProjects: [],
      loading: true,
      loadingText: "Loading",
    };
  },
  mounted: function () {
    console.log(this.selectedInvoiceLines);
    if (!(this.selectedInvoiceLines && this.selectedInvoiceLines.size > 0)) {
      NotificationService.showNotification({
        text: "Please select what should be invoiced",
        timeout: 3000,
        color: "error",
      });
      this.onCancelClick();
      return;
    }
    BookingService.findBookingInvoiceProjects({
      calendarDateId: this.calendarDateId,
    }).then((res) => {
      this.loading = false;
      this.invoiceProjects = res.data.invoice_projects;
    });
  },
  computed: {},
  methods: {
    onCancelClick: function (event) {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function (e, item) {},
    doneAddInvoiceLine: function (res) {
      this.$emit("done", res);
    },
    // onInvoiceProjectClick: function (item) {
    //   this.loading = true;
    //   this.loadingText = "Creating Invoice";

    //   BookingService.createInvoice({
    //     calendarDateId: this.calendarDateId,
    //     invoiceProjectId: item["invoice_project_id"],
    //     invoiceLineIds: `[${Array.from(this.selectedInvoiceLines)
    //       .map((e) => parseInt(e))
    //       .join(",")}]`,
    //   }).then((res) => {
    //     this.emitDone(res.data);
    //   });
    // },
    onInvoiceSelected(selected) {
      const item = this.invoiceProjects?.find((ip) => {
        if (ip.invoice_project_id == Array.from(selected)[0]) {
          return true;
        } else {
          return false;
        }
      });

      if (!item) {
        return;
      }

      this.loading = true;
      this.loadingText = "Creating Invoice";

      BookingService.createInvoice({
        calendarDateId: this.calendarDateId,
        invoiceProjectId: item["invoice_project_id"],
        invoiceLineIds: `[${Array.from(this.selectedInvoiceLines)
          .map((e) => parseInt(e))
          .join(",")}]`,
      }).then((res) => {
        this.emitDone(res.data);
      });
    },
    emitDone: function (data) {
      this.$emit("done", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-project--list {
  max-height: 500px;
  height: 500px;
  overflow: auto;

  .invoice-project--item {
    cursor: pointer;
    height: 40px;
    display: flex;

    flex-direction: column;
    justify-content: center;

    padding: 10px;

    transition: 100ms ease-out;

    &:hover {
      background: var(--sprt-6);
    }

    &:nth-child(even) {
      background-color: var(--sprt-8);
      &:hover {
        background: var(--sprt-6);
      }
    }
  }
}
</style>
